import type { ReactNode } from 'react';
import { useCallback } from 'react';
import type { PrimitiveType } from 'react-intl';
import { useIntl } from 'react-intl';
import { messages } from './messages';

export const useMessage = () => {
  const { formatMessage } = useIntl();

  return useCallback(
    (messageKey: keyof typeof messages, params?: Record<string, unknown>) => {
      if (!messages[messageKey]) {
        console.error(`Message ID ${messageKey} not found`);
        return messageKey;
      }

      // @ts-expect-error TODO: Fix types
      return formatMessage(messages[messageKey], params);
    },
    [formatMessage]
  );
};
